import { render, staticRenderFns } from "./CMoreButtons.vue?vue&type=template&id=134becf9&"
import script from "./CMoreButtons.vue?vue&type=script&lang=js&"
export * from "./CMoreButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports